import { Injectable } from '@angular/core';
import { URITemplates } from '../common/URITemplates'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../services/common.service'
import { Observable,throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { contactUsDTO, printRequestDTO, emailNotificationDTO } from '../models/providersDTO';
@Injectable({
  providedIn: 'root'
})
export class ResultsService {
  objURITemplates: URITemplates = new URITemplates();

  constructor(private http: HttpClient, private commonservice: CommonService) { }

  public getNetworkZipCodes() {
    var path = this.commonservice.getURL(this.objURITemplates.getNetworkZipCodes);
    return this.http.get(path).pipe(
      retry(1),
      catchError(this.handleError)
  );
  }
  public getLatlons(location): any {
    var path = this.commonservice.getURL(this.objURITemplates.getLatlons);
    return this.http.get(path + '?location=' + location).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('getLatlons() error in interceptor' + err);
      return null;
  });
  }
  public getProviders(latitude, longitude, radius, plan, spValue): any {
    var path = this.commonservice.getURL(this.objURITemplates.getProviders);
    const headers = new HttpHeaders({
      'Content-Type':'application/json; charset=utf-8',
      'spValue':spValue
    });

  const requestOptions = { headers: headers };
  
    return this.http.get(path + '?latitude=' + latitude + '&longitude=' + longitude + '&radius=' + radius + '&planName=' + plan + '&spValue=' + spValue,requestOptions).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('getProviders() error in interceptor' + err);
      return null;
  });
  }

  public getFacility(latitude, longitude, radius, plan, spValue, type): any {
    debugger;
    var path = this.commonservice.getURL(this.objURITemplates.getFacility);
    const headers = new HttpHeaders({
      'Content-Type':'application/json; charset=utf-8',
      'spValue':spValue
    });

  const requestOptions = { headers: headers };
    return this.http.get(path + '?latitude=' + latitude + '&longitude=' + longitude + '&radius=' + radius + '&planName=' + plan + '&spValue=' + spValue + '&type=' + type,requestOptions).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('getFacility() error in interceptor' + err);
      return null;
  });
  }
  public getPharmacy(latitude, longitude, radius, plan, spValue): any {
    var path = this.commonservice.getURL(this.objURITemplates.getPharmacy);
    const headers = new HttpHeaders({
      'Content-Type':'application/json; charset=utf-8',
      'spValue':spValue
    });

  const requestOptions = { headers: headers };
    return this.http.get(path + '?latitude=' + latitude + '&longitude=' + longitude + '&radius=' + radius + '&planName=' + plan + '&spValue=' + spValue,requestOptions).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('getPharmacy() error in interceptor' + err);
      return null;
  });
  }


  public SaveContactUsDetails(data: contactUsDTO) {
    var path = this.commonservice.getURL(this.objURITemplates.SaveContactUsDetails);
    return this.http.post(path, data).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('SaveContactUsDetails() error in interceptor' + err);
      return null;
  });
  }
  
  public GetNotificationsContent(title:string) {
   // debugger;
    var path = this.commonservice.getURL(this.objURITemplates.GetNotificationsContent);

    return this.http.get(path+"?title="+title).toPromise().then(result => {
      
      return result;
    }).catch((err)=>{
      console.log('GetNotificationsContent() error in interceptor' + err);
      return null;
  });
  }
  

  public SendEmailNotification(data: emailNotificationDTO) {
    var path = this.commonservice.getURL(this.objURITemplates.sendemails);
    return this.http.post(path, data).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('SendEmailNotification() error in interceptor' + err);
      return null;
  });
  }

  public GetFaq() {
  //  debugger;
    var path = this.commonservice.getURL(this.objURITemplates.getfaq);
    return this.http.get(path).pipe(
      retry(1),
      catchError(this.handleError)
  );
  }
  
  public GetCategories() {
    //debugger;
    var path = this.commonservice.getURL(this.objURITemplates.GetCategories);
    return this.http.get(path).pipe(
      retry(1),
      catchError(this.handleError)
  );
  }
  
  public SavePrintRequest(data: printRequestDTO) {
    var path = this.commonservice.getURL(this.objURITemplates.SavePrintRequest);
    return this.http.post(path, data).toPromise().then(result => {
      return result;
    }).catch((err)=>{
      console.log('SavePrintRequest() error in interceptor' + err);
      return null;
  });
  }
  
  public getAllStates() {
   // debugger;
    var path = this.commonservice.getURL(this.objURITemplates.getAllStates);
    return this.http.get(path).pipe(
      retry(1),
      catchError(this.handleError)
  );
  }

  public getAllPreferences(data:string) {
   // debugger;
    var path = this.commonservice.getURL(this.objURITemplates.getDefaultContent);
    //return this.http.get(path, data).toPromise().then(result => {
      return this.http.get(path+"?fileName="+data).toPromise().then(result => {
     return result;
    }).catch((err)=>{
      console.log('getAllPreferences() error in interceptor' + err);
      return null;
  });
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = 'Error: ${error.error.message}';
    } else {
        // server-side error
        errorMessage = 'Error Code: ${error.status}\nMessage: ${error.message}';
    }
    console.log(errorMessage);
    return throwError(errorMessage);
}

public getProductionDate() {
//  debugger;
  var path = this.commonservice.getURL(this.objURITemplates.getProductionDateTime);
  return this.http.get(path).toPromise().then(result => {
    return result;
  }).catch((err)=>{
    console.log('getProductionDate() error in interceptor' + err);
    return null;
});
}
}


